const flatten = (array)=>[].concat(...array)
;
function extractSkuQuantityPairsFromLineItems(lineItems) {
    // Flatten the result array as we can potentially receive [item, item, [bundleItem, bundleItem]]
    return flatten(lineItems.map((lineItem)=>{
        if ('sku' in lineItem) {
            return [
                {
                    sku: lineItem.sku,
                    quantity: lineItem.quantity
                }, 
            ];
        }
        // If the lineItem has no SKU, assume it's an aggregated (prescription) product
        return [
            lineItem.frame,
            lineItem.lensType,
            lineItem.lensPackage,
            lineItem.addOn
        ].map((item)=>{
            return {
                sku: (item === null || item === void 0 ? void 0 : item.sku) || '',
                quantity: 1
            };
        });
    }));
}

export { extractSkuQuantityPairsFromLineItems };
//# sourceMappingURL=extract-sku-qauntity-pairs.js.map
